import { NgClass } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CoinflipService } from '@features/coinflip/coinflip.service';
import { ChatMessage, ChatMessageContent } from '@models/chat-message.interface';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-chat-game-event',
  templateUrl: './chat-game-event.component.html',
  styleUrls: ['./chat-game-event.component.scss'],
  imports: [IconComponent, CurrencyComponent, NgClass],
})
export class ChatGameEventComponent implements OnChanges {
  @Input() event: ChatMessage;
  content: ChatMessageContent;

  gameNames: Record<string, string> = {
    casebattles: 'Case Battle',
    coinflip: 'Coinflip',
  };

  constructor(private router: Router, private coinflipService: CoinflipService) {}

  ngOnChanges(): void {
    if (this.event && this.event.content) {
      this.content = this.event.content as ChatMessageContent;
    }
  }

  watchGame() {
    if (!this.content) {
      return;
    }

    if (this.content.game === 'casebattles') {
      this.router.navigate(['/battles', this.content.uid]);
    } else if (this.content.game === 'coinflip') {
      this.coinflipService.viewCoinflipById(+this.content.uid);
    }
  }
}
